import { Hidden }                from "@material-ui/core";
import * as React                from "react";
import { Component, ReactNode }  from "react";
import { Loader }                from "semantic-ui-react";
import FetchStatus               from "../../domain/fundamentals/fetch/FetchStatus";
import MenuType                  from "../../domain/menu/MenuType";
import ContractPeriodInformation from "../components/common/ContractPeriodInformation";
import RightPositionSection      from "../components/common/layout/RightPositionSection";
import NotifyDisplay             from "../components/notify/NotifyDisplay";
import StaffInfo                 from "../components/staff/StaffInfo";
import GetAccountContainer       from "./GetAccountContainer";
import Header                    from "./HeaderContainer";
import Menu                      from "./MenuContainer";
import "./ResKaBase.scss";

export interface BaseProps {
  fetchStatus: FetchStatus;
}

export interface BaseState {
  menuType: MenuType;
  headerTitle: string;
}

abstract class ResKaBaseContainer<P extends BaseProps, S extends BaseState> extends Component<P, S> {
  protected constructor(props: P, state: S) {
    super(props);
    this.state = state;
  }

  public componentDidMount(): void {
    this.componentDidMountInternal();
  }

  public render(): ReactNode {
    const {menuType, headerTitle} = this.state;
    return (
      <>
        <Menu menuType={ menuType }/>
        <Header headerTitle={ headerTitle }/>
        <ContractPeriodInformation/>
        <GetAccountContainer/>
        <NotifyDisplay/>
        <Loader active={ this.props.fetchStatus.isFetching() }/>
        <Hidden smDown={ true }>
          <main className="reska-base reska-base-md">
            <RightPositionSection>
              <StaffInfo/>
            </RightPositionSection>
            { this.renderInternal() }
          </main>
        </Hidden>
        <Hidden mdUp={ true }>
          <main className="reska-base reska-base-sm">
            <RightPositionSection>
              <StaffInfo/>
            </RightPositionSection>
            { this.renderInternal() }
          </main>
        </Hidden>
      </>
    );
  }

  protected abstract renderInternal(): ReactNode;

  protected abstract componentDidMountInternal(): void;
}

export default ResKaBaseContainer;
